/**
 * Post Slider Frontend Script
 * Initializes Splide.js for the post slider
 */

function bl_initPostSlider(container = document) {
  // Initialize all post sliders
  const sliders = container.querySelectorAll(".post-slider");

  sliders.forEach((slider) => {
    if (slider.dataset.initialized === "true") return;

    // Get slider options from data attributes or use defaults
    const autoplay = slider.dataset.autoplay !== "false";
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 3000;
    const autoWidth = slider.dataset.autoWidth === "true";
    const autoHeight = slider.dataset.autoHeight === "true";
    const center = slider.dataset.center === "true";
    const autoScroll = slider.dataset.autoscroll === "true";
    const loop = slider.dataset.loop === "true";
    const fixedPerPage = Number(slider.dataset.fixedPerPage);

    const breakpoints = (() => {
      if (fixedPerPage) {
        return {
          1024: {
            perPage: fixedPerPage,
          },
          768: {
            gap: "1rem",
            perPage: 1,
            padding: {
              right: "1rem",
            },
          },
        };
      }

      // only if not autoscrolling
      if (autoScroll)
        return {
          768: {
            gap: "1rem",
          },
        };

      return {
        3000: {
          perPage: 7.3,
        },
        2560: {
          perPage: 6.3,
        },
        1920: {
          perPage: 5.3,
        },
        1536: {
          perPage: 4.3,
        },
        1280: {
          perPage: 3.3,
        },
        1024: {
          perPage: 2.3,
        },
        768: {
          gap: "1rem",
          perPage: 1.7,
          padding: {
            left: "1rem",
          },
        },
        480: {
          perPage: 1.2,
        },
      };
    })();

    // Initialize Splide
    new Splide(slider, {
      type: loop ? "loop" : "slide",
      perMove: 1,
      autoplay: autoplay,
      interval: autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: "free",
      clones: loop ? 20 : undefined,
      pagination: false,
      arrows: false,
      autoWidth: autoWidth && autoScroll,
      autoHeight: autoHeight,
      center: center,
      // responsive
      perPage: fixedPerPage || 8.1,
      gap: "4rem",
      padding: {
        left: "2rem",
      },
      breakpoints: {
        ...breakpoints,
        // Override center behavior on mobile for fixed per page sliders
        ...(fixedPerPage && {
          768: {
            ...breakpoints[768],
            center: false,
          },
        }),
      },
      autoScroll: autoScroll
        ? {
            speed: 0.5,
          }
        : false,
    }).mount(window.splide.Extensions);

    slider.dataset.initialized = "true";
  });
}

// Register slideshow initialization with the Bauland event system
document.addEventListener("DOMContentLoaded", () => {
  bl_initPostSlider();
});

document.addEventListener("bauland:contentLoaded", function (event) {
  bl_initPostSlider(event.detail.container);
});
